// @ts-nocheck
import axios from '../utils/axios';
import { ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT, ONLINE_REPORT_SERVICE_API_ENDPOINT } from '../config';
import { catchAsync } from '../utils/api';

const getStatuses = catchAsync(async () => {
    const result = await axios.get(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/static/data/statuses`);

    return result.data;
});

const getCities = catchAsync(async () => {
    const result = await axios.get(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/static/data/cities`);

    return result.data;
});

const getClientTypes = catchAsync(async () => {
    const result = await axios.get(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/static`);

    return result.data;
});

const getActivities = catchAsync(async () => {
    const result = await axios.get(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/static/activity`);

    return result.data;
});
const getActionTypes = catchAsync(async () => {
    const result = await axios.get(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/static/action-type`);

    return result.data;
});

const getBalanceActivities = catchAsync(async () => {
    const result = await axios.get(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/static/balanceActivity`);

    return result.data;
});
const getPaymentMethods = catchAsync(async () => {
    const result = await axios.get(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/static/payment-method`);

    return result.data;
});

const getGroupByOptions = catchAsync(async params => {
    const result = await axios.get(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/static/groupBy`, { params });

    return result.data;
});
const getPaymentProviders = catchAsync(async () => {
    const result = await axios.get(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/static/payment-provider`);

    return result.data;
});

const getConditionTypes = catchAsync(async () => {
    const result = await axios.get(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/static/condition-type`);

    return result.data;
});

const getOperationTypes = catchAsync(async () => {
    const result = await axios.get(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/static/operation-type`);

    return result.data;
});

const getWithdrawRuleConditions = catchAsync(async () => {
    const result = await axios.get(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/static/withdraw-rule-condition`);

    return result.data;
});

const getUserStatus = catchAsync(async () => {
    const result = await axios.get(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/static/userStatus`);

    return result.data;
});

const getFreezeType = catchAsync(async () => {
    const result = await axios.get(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/static/freezeType`);

    return result.data;
});

const getPlayerMassUpdateActionTypes = catchAsync(async () => {
    const result = await axios.get(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/static/playerMassUpdate`); //TODO camelcase

    return result.data;
});

const getWalletType = catchAsync(async () => {
    const result = await axios.get(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/static/wallet-type`);

    return result.data;
});

const getPlayerSegmentFilterTypes = catchAsync(async () => {
    const result = await axios.get(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/static/player-segment-filter-type`);

    return result.data;
});

const getArchiveStatuses = catchAsync(async () => {
    const result = await axios.get(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/static/archive-status`);

    return result.data;
});

const getCommunicationCategories = catchAsync(async () => {
    const result = await axios.get(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/static/communication-category`);

    return result.data;
});

const getCommunicationChannels = catchAsync(async () => {
    const result = await axios.get(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/static/communication-channel`);

    return result.data;
});

const getCommunicationDirections = catchAsync(async () => {
    const result = await axios.get(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/static/direction`);

    return result.data;
});

const getMessageStatuses = catchAsync(async () => {
    const result = await axios.get(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/static/message-status`);

    return result.data;
});

const getNoteCategories = catchAsync(async () => {
    const result = await axios.get(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/static/note-categories`);

    return result.data;
});

const getRequestMethods = catchAsync(async () => {
    const result = await axios.get(`${ONLINE_REPORT_SERVICE_API_ENDPOINT}/audit-trail-report/description`);

    return result.data;
});

const getTicketOperationTypes = catchAsync(async () => {
    const result = await axios.get(
        `${ONLINE_REPORT_SERVICE_API_ENDPOINT}/ticket-operations/properties/operation-types`,
    );

    return result.data;
});

const getTicketOperationStatuses = catchAsync(async () => {
    const result = await axios.get(`${ONLINE_REPORT_SERVICE_API_ENDPOINT}/ticket-operations/properties/statuses`);

    return result.data;
});

const getSources = catchAsync(async () => {
    const result = await axios.get(`${ONLINE_REPORT_SERVICE_API_ENDPOINT}/source-channels`);

    return result.data;
});

const StaticDataService = {
    getStatuses,
    getCities,
    getClientTypes,
    getActivities,
    getBalanceActivities,
    getGroupByOptions,
    getActionTypes,
    getPaymentMethods,
    getPaymentProviders,
    getSources,
    getConditionTypes,
    getOperationTypes,
    getWithdrawRuleConditions,
    getUserStatus,
    getFreezeType,
    getPlayerMassUpdateActionTypes,
    getWalletType,
    getPlayerSegmentFilterTypes,
    getArchiveStatuses,
    getCommunicationCategories,
    getCommunicationChannels,
    getCommunicationDirections,
    getMessageStatuses,
    getNoteCategories,
    getRequestMethods,
    getTicketOperationTypes,
    getTicketOperationStatuses,
};

export default StaticDataService;
